<template>
  <v-responsive class="overflow-y-auto" :max-height="$store.state.maxHeight">
    <v-timeline>
      <v-timeline-item
        v-for="(year, i) in dataMsg"
        :key="i"
        :color="year.color"
        small
      >
        <template v-slot:opposite>
          <v-img :src="year.img"></v-img>
        </template>
        <div class="py-4">
          <h2 :class="`headline font-weight-light mb-4 ${year.color}--text`">服务客户</h2>
          <div>
            {{ year.company }}
          </div>
          <h2 :class="`headline font-weight-light mb-4 ${year.color}--text`">资源配置</h2>
          <div>
            {{ year.resource }}
          </div>
          <h2 :class="`headline font-weight-light mb-4 ${year.color}--text`">项目概要</h2>
          <div>
            {{ year.desc }}
          </div>
        </div>
      </v-timeline-item>
    </v-timeline>
  </v-responsive>
</template>

<script>

  export default{
    data(){
      return{
        // dataMsg:[

        //   {color: 'green',img:'../../../static/waibao/hx.png',company:'海信集团有限公司、青岛海信网络科技有限公司、青岛海信电子技术有限公司、青岛赛维电子信息服务股份有限公司、海信视像科技股份有限公司',resource:'初中级开发人员38人、高级开发人员6人、资深开发人员1人',desc:'平安城市实战平台组、车辆大数据系统组、视频侦查可视化指挥组、智慧校园组、交通运输组、城市交通组、移动通信组、国际营销组、日本CRM组、商用展示组、智能商用SMS组、海信绩效与督办系统组'},
        //   {color: 'blue',img:'../../../static/waibao/he.png',company:'青岛中软动力信息产业有限公司、百腾(大连)科技有限公司、济南百思为科信息工程有限公司、青岛铭威软创信息有限公司',resource:'初中级开发人员38人、高级开发人员6人、资深开发人员1人',desc:'消费金融项目组、音志达大数据组、三菱重工智慧项目、地产销售项目、报表中心项目、里奈商城项目、佣金模块项目'},
        //   {color: 'indigo',img:'../../../static/waibao/kdxf.png',company:'上海旌利信息技术有限公司',resource:'中级开发人员20人、高级开发人员4人',desc:'科大讯飞-智慧城市项目组'},
        //   {color: 'red',img:'../../../static/waibao/zglt.png',company:'北京和鸿盈科技术有限公司、山东盈高网络科技有限公司、广州市易杰数码科技有限公司、北京国电海通科技发展有限公司',resource:'初中级开发人员38人、高级开发人员6人、资深开发人员1人',desc:'联通内部商城组、12345服务热线组、大数据服务组、应急指挥系统、大数据服务组、应急指挥系统'},
        //   {color: 'orange',img:'../../../static/waibao/soft.png',company:'青岛方天股份有限公司、青岛嘉元正合技术有限公司',resource:'初中级开发人员24人、高级开发人员15人',desc:'华电项目、作业安全管控项目组、电网数据应用部、微服务微应用、电网公网通信、输电管控平台、电科院、中国足协、研发中心'},
        //   {color: 'teal',img:'../../../static/waibao/gjdw.png',company:'北京华路时代信息技术股份有限公司',resource:'初级开发人员17人、中级开发人员45人、高级开发人员8人',desc:'综合能源服务中心平台、营销移动作业项目、机器人平台、变电站在线检测平台、物资质控平台、营销移动作业平台、变电五通作业项目、营销2.0平台'},
        //   {color: 'cyan',img:'../../../static/waibao/mgyd.png',company:'杭州东信北邮信息技术有限公司',resource:'初级开发人员6人、中级开发人员18人、高级开发人员2人',desc:'图书业务管理子系统、听书业务管理子系统、杂志业务管理子系统、漫画业务管理子系统、通用业务管理子系统、手机报业务管理子系统'},
        // ],
         dataMsg :[
  {
    color: 'green',
    img: '../../../static/waibao/hx.png',
    company: '海信集团有限公司、青岛海信网络科技有限公司、青岛海信电子技术有限公司、青岛赛维电子信息服务股份有限公司、海信视像科技股份有限公司',
    resource: '初中级开发人员38人、高级开发人员6人、资深开发人员1人',
    desc: '平安城市实战平台组、车辆大数据系统组、视频侦查可视化指挥组、智慧校园组、交通运输组、城市交通组、移动通信组、国际营销组、日本CRM组、商用展示组、智能商用SMS组、海信绩效与督办系统组'
  },
  {
    color: 'gray',
    img: '../../../static/waibao/sdgs.png',
    company: '山东通维信息工程有限公司',
    resource: '高级开发人员4人、中级开发人员8人',
    desc: '山东高速智能运维项目'
  },
  {
    color: 'blue',
    img: '../../../static/waibao/he.png',
    company: '青岛中软动力信息产业有限公司、百腾(大连)科技有限公司、济南百思为科信息工程有限公司、青岛铭威软创信息有限公司',
    resource: '初中级开发人员38人、高级开发人员6人、资深开发人员1人',
    desc: '消费金融项目组、音志达大数据组、三菱重工智慧项目、地产销售项目、报表中心项目、里奈商城项目、佣金模块项目'
  },
  {
    color: 'indigo',
    img: '../../../static/waibao/kdxf.png',
    company: '上海旌利信息技术有限公司',
    resource: '中级开发人员20人、高级开发人员4人',
    desc: '科大讯飞-智慧城市项目组'
  },
  {
    color: 'red',
    img: '../../../static/waibao/zglt.png',
    company: '北京和鸿盈科技术有限公司、山东盈高网络科技有限公司、广州市易杰数码科技有限公司、北京国电海通科技发展有限公司',
    resource: '初中级开发人员38人、高级开发人员6人、资深开发人员1人',
    desc: '联通内部商城组、12345服务热线组、大数据服务组、应急指挥系统、大数据服务组、应急指挥系统'
  },
  {
    color: 'orange',
    img: '../../../static/waibao/soft.png',
    company: '青岛方天股份有限公司、青岛嘉元正合技术有限公司',
    resource: '初中级开发人员24人、高级开发人员15人',
    desc: '华电项目、作业安全管控项目组、电网数据应用部、微服务微应用、电网公网通信、输电管控平台、电科院、中国足协、研发中心'
  },
  {
    color: 'teal',
    img: '../../../static/waibao/gjdw.png',
    company: '北京华路时代信息技术股份有限公司',
    resource: '初级开发人员17人、中级开发人员45人、高级开发人员8人',
    desc: '综合能源服务中心平台、营销移动作业项目、机器人平台、变电站在线检测平台、物资质控平台、营销移动作业平台、变电五通作业项目、营销2.0平台'
  },
  {
    color: 'cyan',
    img: '../../../static/waibao/mgyd.png',
    company: '杭州东信北邮信息技术有限公司',
    resource: '初级开发人员6人、中级开发人员18人、高级开发人员2人',
    desc: '图书业务管理子系统、听书业务管理子系统、杂志业务管理子系统、漫画业务管理子系统、通用业务管理子系统、手机报业务管理子系统'
  },
  {
    color: 'purple',
    img: '../../../static/waibao/shengruan.png',
    company: '山东胜软科技股份有限公司',
    resource: '高级开发人员7人、中级开发人员17人',
    desc: '石化智云油田服务项目组、智能油气平台、石化研究院项目'
  },
  {
    color: 'pink',
    img: '../../../static/waibao/zcrj.png',
    company: '山东中创软件工程股份有限公司',
    resource: '高级开发人员2人、中级开发人员5人',
    desc: '银行租赁金融项目、招商局供应链项目'
  },
  
  {
    color: 'brown',
    img: '../../../static/waibao/huatian.png',
    company: '山东山大华天软件有限公司、',
    resource: '高级开发人员6人、中级开发人员13人',
    desc: '3DPlaza-云capp项目、中船重工PLM集成接口开发及实施项目、上汽试制数字化项目'
  },
  {
    color: 'gray',
    img: '../../../static/waibao/gjdw.png',
    company: '山东鲁能软件有限公司',
    resource: '高级开发人员5人、中级开发人员14人',
    desc: '作业安全管控项目、输电管控平台项目'
  },
],
      }
    },
    mounted(){

    },
    methods: {
    },
    computed: {
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/waibao/serviceCase.vue